import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Editor from 'components/editor'
import SelectInput from '@mui/material/Select/SelectInput'

const CreateModal = ({ appData, handleRefresh, appCollections }) => {
  appCollections = appCollections.filter((data) => data.app_id === appData?.app_id)

  const uploadImage = useUploadImage()
  const { app_id } = useParams
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()
  const [ActionCategoryList, setActionCategoryList] = useState([])
  const [loader, setloader] = useState(true)
  var axios = require('axios')

  const getActionCategories = async () => {
    const { response } = await AppService.AppCollections.get({
      query: `app_id=${appData?.app_id}`,
    })
    // console.log(response, 'request_app')
    if (response) {
      setActionCategoryList(response.data)
    } else {
      setActionCategoryList([])
    }
    setloader(false)
  }

  const onLoad = () => {
    getActionCategories()
  }

  useEffect(onLoad, [])


  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => { }, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [editor, setEditor] = useState('')

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      //   const image_response = await uploadImage({
      //     file: e.target.image.files[0],
      //     desiredPath: `app/logo/image`,
      //   })
      const videpdata = {
        name: e.target.name.value,
        description: editor,
        link: e.target.link.value,
        app_collection_id: e.target.app_collection_id.value,
        // image: image_response.response.data,
      }
      const payload = {
        _id: appData._id,
        actions: [...appData.actions, videpdata],
      }
      // console.log(payload)

      const { response } = await AppService.app.update({
        payload: payload,
      })
      // console.log(response)
      if (response) {

        const payload_collection = {
          app_id: appData.app_id,
          id: e.target.app_collection_id.value,
          actions: [
            ...appCollections.find((data) => data._id === e.target.app_collection_id.value).actions,
            videpdata,
          ],
        }
        const res = AppService.AppCollections.update({
          payload: payload_collection
        })
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              App Action
            </MDTypography>
            {/* <MDBox mb={2} ml={1} display="flex" alignItems="center">
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                                    Upload Image +
                                    <input hidden name="image" type="file" />
                                </Button>
                            </Stack>
                        </MDBox> */}
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <Editor
                handleChange={(data) => {
                  setEditor(data)
                }}
                data={editor}
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Youtube Link
              </MDTypography>
              <MDInput label="Youtube Link" name="link" fullWidth />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Select Collection
              </MDTypography>
              <Select placeholder="Actions Category" name="app_collection_id" fullWidth>
                {appCollections?.map((data) => (
                  <MenuItem value={data?._id}>
                    {data?.name}
                  </MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create Action
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
